import React, { Component } from 'react';
import Slider from 'react-slick';

export default class CustomSlider extends Component {
  defaultPlayersOptions = {
    dots: true,
    infinite: true,
    lazyLoad: false,
    easing: 'ease',
    swipe: false,
    responsive: [{
      breakpoint: 997,
      settings: {
        swipe: true
      }
    }]
  }

  render() {
    const { className, children } = this.props;
    return(
      <Slider {...this.defaultPlayersOptions} className={className}>
        { children }
      </Slider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomSlider.js